import { createContext } from 'react';
import { IGiftItemProviderProps } from '@monofront/types';

const GiftItemContext = createContext<Omit<IGiftItemProviderProps, 'children'>>(
  {
    products: [],
  },
);

/**
 * Context who takes gift items products and make them accessible to the app
 * @param products current gift items get from Prismic
 * @returns GiftItemContext, GiftItemProvider
 */
const GiftItemProvider: React.FC<IGiftItemProviderProps> = ({
  children,
  products,
}) => {
  return (
    <GiftItemContext.Provider value={{ products }}>
      {children}
    </GiftItemContext.Provider>
  );
};

export { GiftItemContext, GiftItemProvider };
